/**
 * Navigation configuration constants for Android back button handling
 */

/**
 * Routes that should exit the app when back button is pressed
 * instead of navigating to previous page.
 * All main bottom-nav tabs are root routes — pressing back on any of them
 * should trigger the double-tap-to-exit pattern rather than going back.
 */
export const ROOT_ROUTES = [
  '/',
  '/dashboard',
  '/leads',
  '/tasks',
  '/tools',
] as const;

/**
 * Time window (in milliseconds) for double-tap-to-exit pattern
 * User must press back button twice within this time to exit the app
 */
export const EXIT_CONFIRMATION_TIMEOUT = 2000; // 2 seconds

/**
 * Message shown to user when they press back on a root route
 * Prompts them to press back again to confirm exit
 */
export const EXIT_CONFIRMATION_MESSAGE = 'Press back again to exit';

/**
 * Check if a given path is a root route that should trigger app exit
 */
export const isRootRoute = (path: string): boolean => {
  return ROOT_ROUTES.includes(path as typeof ROOT_ROUTES[number]);
};
